import type React from "react";
import { unreadBadgeVariants } from "@/components/common/Badge";
import { cn } from "@/lib/utils";

type UnreadBadgeVariant = "unreadActivity" | "mention";

export interface UnreadBadgeItem {
  count: number;
  label: string;
  variant: UnreadBadgeVariant;
  prefix?: string;
}

interface UnreadBadgeStackProps {
  items: UnreadBadgeItem[];
  className?: string;
  direction?: "row" | "column";
  align?: "start" | "center" | "end";
  display?: "flex" | "inline-flex";
}

export const UnreadBadgeStack: React.FC<UnreadBadgeStackProps> = ({
  items,
  className,
  direction = "column",
  align = "start",
  display = "flex",
}) => {
  const visibleItems = items.filter((item) => item.count > 0);

  if (visibleItems.length === 0) {
    return null;
  }

  const directionClass = direction === "row" ? "flex-row" : "flex-col";
  const alignClass = `items-${align}`;
  const displayClass = display;

  return (
    <span
      className={cn(
        displayClass,
        directionClass,
        alignClass,
        "gap-1",
        className,
      )}
    >
      {visibleItems.map((item) => (
        <span
          key={`${item.variant}-${item.label}`}
          className={unreadBadgeVariants({ intent: item.variant })}
          title={item.label}
        >
          {item.prefix ?? ""}
          {item.count}
        </span>
      ))}
    </span>
  );
};
